import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/forgot-password/page.tsx");
